import "./processing-indicator.scss";
import { observer } from "mobx-react";
import LinearLoader from "../../../components/loaders/linear-loader/linear-loader";
import ShopsSelectorStore from "../shops-selector-store";

interface LoaderProps {
    store: ShopsSelectorStore;
}

const ProcessingIndicator: React.FC<LoaderProps> = observer(({ store }) => {
    return (
        store.isProcessing
            ? <div className="processing-indicator">
                <LinearLoader />
            </div>
            : null
    );
});

export default ProcessingIndicator;
